<!-- <div class="dialog-header mb-5">
	<div class="dialog-title mb-1" *ngIf="data.title || data.copy">
		<h1 class="title mb-1" mat-dialog-title>{{ data.title }}</h1>
		<div class="copy" *ngIf="data.copy">{{data.copy}}</div>
	</div>
</div> -->

<div mat-dialog-content>
	<app-template-selector
		[elements]="elements$ | async"
		[tableCollection]="data.tableCollection"
		[gridCollection]="data.gridCollection"
		[selectType]="data.selectType"
		[viewMode]="data.viewMode"
		[viewModeOptions]="data.viewModeOptions"
		[categories]="data.categories"
		[selectedElements]="selectedElements"
		[uiSettings]="data | transformObject: generateAssetTemplateSelectUiSettings"
		[copySettings]="data | transformObject: generateAssetTemplateSelectCopySettings"
		(selectionChange)="onSelectionChange($event)"
		(add)="add.emit($event)"
		(cancel)="dialogRef.close()"
	>
	</app-template-selector>

</div>



<div class="bottom-bar">
	<div class="selections-info">
		<ng-container *ngIf="data.showSelectedCount && data.selectType === 'multiple' && selectedElements.length">
			{{selectedElements.length | textSingularPlural: data.elementTitle: data.elementTitlePlural}} selected
		</ng-container>
	</div>

	<div class="buttons">
		<button mat-button color="secondary" class="block secondary-button" (click)="dismiss()" *ngIf="data.showCancelButton">
			<ng-container *ngIf="data.cancelButtonCta">{{data.cancelButtonCta}}</ng-container>
			<ng-container *ngIf="!data.cancelButtonCta" i18n="Cancel Button@@assetTemplateSelectorDialogCancelButtonLabel">Cancel</ng-container>
		</button>
		<button mat-flat-button color="primary" class="block button-border-radius"
				*ngIf="data.showSubmitButton"
				[disabled]="!data.allowEmptySelection && !selectedElements.length"
				(click)="confirm()">
			<ng-container *ngIf="data.submitButtonCta">{{data.submitButtonCta}}</ng-container>
			<ng-container *ngIf="!data.submitButtonCta" i18n="Choose Button@@assetTemplateSelectorDialogChooseButtonLabel">Choose</ng-container>
		</button>
	</div>
</div>
